var userID,obj,product_ID,design_ID,design_Name,requiredId,pro,item,url,proTitle,imgUrl;
jQuery(document).ready(function(){
  userID = jQuery('#customerID').text();
  $.ajax({
    url: "https://homefirst.pk/poker/listing.php",
    type: "POST",
    data:{
      userID: userID
    },
    success: function(response){
      obj = jQuery.parseJSON(response);
      loadMyDesigns(obj);
    }
  });
});

function loadMyDesigns(obj){
  $.ajax({
    type: 'GET',
    url: '/products.json',
    dataType: 'json',
    success: function(res){
      for(var p=0; p < res.products.length ; p++){
        pro = res.products[p];
        requiredId = pro.id;
        for(var i=0; i < obj.length ; i++){
          pro_ID	= obj[i].productID;
          des_Name	= obj[i].designName;
          des_ID	= obj[i].design_id;
          if(pro_ID == requiredId){
            url = '/products/'+pro.handle;
            proTitle = pro.title;
            imgUrl = pro.images[0].src;
            item = '<li class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"><div class="grid-view-item product-card">'+
              '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="'+ url +'?id='+des_ID+'">'+
              '<span class="visually-hidden">'+proTitle+'</span></a><div class="product-card__image-with-placeholder-wrapper" '+
              'data-image-loading-animation><div id="ProductCardImageWrapper-'+des_ID+'-'+pro_ID+'" class="grid-view-item__image-wrapper product-card__image-wrapper js">'+
              '<div style="padding-top:100%;"><img id="ProductCardImage-'+des_ID+'-'+pro_ID+'" class="grid-view-item__image lazyload" alt="'+proTitle+'" data-src="'+imgUrl+'"'+
              'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image>'+
              '</div></div></div><div class="h4 grid-view-item__title product-card__title" aria-hidden="true">'+des_Name+'</div></div>';
            jQuery('#myDesignsList').append(item);
          }
        }
      }
      jQuery('.loadingPage').hide();
    },
    error: function(status){
      console.log(status);
    }
  });
}